module.exports = __webpack_public_path__ + "static/media/6.03cea1ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/400/6.png
// module id = 739
// module chunks = 0